/**
 * Breadcrumb tracking for error context
 * Feature-flagged to allow gradual rollout
 */

interface BreadcrumbInput {
  category: 'navigation' | 'user_action' | 'api_call' | 'state_change' | 'console'
  message: string
  data?: Record<string, unknown>
  timestamp?: number // Optional, will be set automatically
}

interface Breadcrumb extends BreadcrumbInput {
  timestamp: number // Required in stored breadcrumb
}

class BreadcrumbTracker {
  private breadcrumbs: Breadcrumb[] = []
  private readonly MAX_BREADCRUMBS = 50
  private enabled: boolean

  constructor() {
    // Feature flag: Enable via environment variable
    this.enabled = typeof window !== 'undefined' 
      ? process.env['NEXT_PUBLIC_ENABLE_BREADCRUMBS'] === 'true'
      : false
    
    console.log('[Breadcrumbs] Initialized')
    console.log('[Breadcrumbs] Env var:', process.env['NEXT_PUBLIC_ENABLE_BREADCRUMBS'])
    console.log('[Breadcrumbs] Enabled:', this.enabled)
  }

  add(breadcrumb: BreadcrumbInput): void {
    if (!this.enabled) return

    // Circular buffer: remove oldest if at max
    if (this.breadcrumbs.length >= this.MAX_BREADCRUMBS) {
      this.breadcrumbs.shift()
    }

    this.breadcrumbs.push({
      ...breadcrumb,
      timestamp: breadcrumb.timestamp || Date.now()
    })
  }

  getAll(): Breadcrumb[] {
    return [...this.breadcrumbs] // Return copy
  }

  clear(): void {
    this.breadcrumbs = []
  }

  isEnabled(): boolean {
    return this.enabled
  }
}

// Singleton instance
export const breadcrumbTracker = new BreadcrumbTracker()

// Attach to window for debugging
if (typeof window !== 'undefined') {
  (window as any).breadcrumbTracker = breadcrumbTracker
  console.log('[Breadcrumbs] Attached to window:', breadcrumbTracker.isEnabled())
}

